export function formatStoreDate(
  value: string,
  locale: string = "en-GB",
): string {
  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString(locale);
  }

  // Play API often returns "Jun 2, 2026"
  const loose = Date.parse(value);
  if (!Number.isNaN(loose)) {
    return new Date(loose).toLocaleDateString(locale);
  }

  return value;
}
